import React from "react";
import { observer } from "mobx-react";
import classnames from "classnames";
import CheerEmotes from "./CheerEmotes";
import CheerConfetti from "./CheerConfetti";
import CheerBottomBar from "./CheerBottomBar";
import CheerConfettiBottomBar from "./CheerConfettiBottomBar";
import useCheersStore from "../../../../../common/hooks/useCheersStore";
import style from "./Cheer.module.scss";
import { portBitsProductToSelectOption } from "../../../../../common/utils/portBitsProductToSelectOption";
import Loader from "../../../../../common/components/Loader";
import GA from "../../../../../common/services/GA";

const Cheer: React.FC = observer(() => {
  const cheersStore = useCheersStore();
  const { emotes, error } = cheersStore.emotesList;

  if (error) return <div className={style.cheer__warningInfo}>{error.message}</div>;

  if (!emotes)
    return (
      <div className={style.cheer__warningInfo}>
        <Loader />
      </div>
    );

  const renderSuccessView = (): React.ReactNode => {
    if (!cheersStore.boughtProductData) {
      return;
    }

    return (
      <div
        className={classnames(style.cheer__successView, {
          [style.cheer__successView_visible]: cheersStore.isSuccessViewVisible,
        })}
      >
        <div className={style.cheer__content}>
          <CheerConfetti selectedEmoteSrc={cheersStore.boughtProductData.emote.imageUrl} />
        </div>
        <div className={style.cheer__bottomBar}>
          <CheerConfettiBottomBar bitsAmount={cheersStore.boughtProductData.bitsAmount} />
        </div>
      </div>
    );
  };

  const onButtonClick = (): void => {
    cheersStore.buyProduct();
    if (cheersStore.selectedEmote && cheersStore.selectedProduct) {
      GA.sendEvent(
        "click",
        `cheer_${cheersStore.selectedEmote.name}_${cheersStore.selectedProduct.cost.amount}`,
        cheersStore.selectedEmote.id,
        Number(cheersStore.selectedProduct.cost.amount)
      );
    }
  };

  return (
    <div className={style.cheer}>
      <div className={style.cheer__content}>
        <CheerEmotes emotes={emotes} />
      </div>
      <div className={style.cheer__bottomBar}>
        <CheerBottomBar
          isButtonDisabled={!cheersStore.selectedProduct || !cheersStore.selectedEmote}
          onButtonClick={onButtonClick}
          selectOptions={cheersStore.products?.map((product) => portBitsProductToSelectOption(product))}
          onSelectChange={(option) => cheersStore.selectProduct(option.value)}
          selectedOption={
            cheersStore.selectedProduct ? portBitsProductToSelectOption(cheersStore.selectedProduct) : null
          }
        />
      </div>
      {renderSuccessView()}
    </div>
  );
});

export default Cheer;
